module.exports = function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Ajouter vos préférences beauté',
        skipThisQuestion: 'Ignorer cette question',
        next: 'Suivant',
        done: 'Terminé',
        modalSubTitle1: 'Félicitations! Vous êtes désormais membre Beauty Insider.',
        modalSubTitle2: 'Parlez-nous de vous pour obtenir une expérience de magasinage personnalisée.',
        apiErrorModalTitle: 'Modifications non enregistrées',
        apiErrorModalMessage: 'Un problème est survenu lors du traitement de votre soumission. Veuillez essayer de nouveau.',
        buttonText: 'Compris',
        savedTitle: 'Préférences beauté enregistrées',
        savedMessage1: 'Vos préférences ont été enregistrées. Allez à vos préférences beauté pour ',
        linkText: 'modifier vos réponses',
        savedMessage2: ' ou pour nous en dire plus.',
        keepGoing: 'Continuez'
    };

    return resources[label];
};
